export default "__VITE_ASSET__B5q98C6f__"